import { Drawer } from 'antd';
import type { GetProps } from 'antd';
import classes from './index.module.scss';
import BackICon from './images/back.svg?react';
import CloseICon from './images/close.svg?react';

type PropsType = GetProps<typeof Drawer>;

interface ChatSettingDrawerProps {
  className?: string;
  text?: React.ReactNode;
  children?: React.ReactNode;
  onCancel?: () => void;
  onClose?: () => void;
  onBack?: () => void;
}

const ChatSettingDrawer = ({
  className,
  text,
  children,
  onCancel,
  onBack,
  ...props
}: ChatSettingDrawerProps & PropsType) => {
  return (
    <Drawer
      rootClassName={cls(classes.chatSettingDrawer, className)}
      closable={false}
      // maskClosable={false}
      styles={{
        header: {
          padding: '24px 16px 10px',
        },
        body: {
          padding: 0,
        },
        mask: {
          backgroundColor: 'transparent',
        },
        ...props.styles,
      }}
      title={
        <Flex justify="space-between">
          <Flex
            align="center"
            onClick={() => onBack?.()}
            className={cls(!!onBack && 'pointer')}
          >
            {!!onBack && <BackICon></BackICon>}
            <div className={classes.title}>{text}</div>
          </Flex>
          <Flex gap={10} align="center">
            {/* <ShareIcon className="pointer" onClick={onShare} /> */}
            <CloseICon className="pointer" onClick={onCancel} />
          </Flex>
        </Flex>
      }
      {...props}
    >
      {children}
    </Drawer>
  );
};

export default ChatSettingDrawer;
